import {PhoneHQGlyph} from 'ch3-ui-lib';

interface GoogleStatusProps {
    status: boolean;
}
export const GoogleStatus = ({status}: GoogleStatusProps) => {
    const getGoogleStatus = (googleStatus: boolean) => {
        switch (googleStatus) {
            case true:
                return (
                    <span className="text-success-ink flex items-center gap-2">
                        <span className={'bg-success-tint p-[6px] rounded-full'}>
                            <span className="inline-flex size-3 shrink-0 items-center justify-center rounded-full bg-success-tint text-success-ink"><PhoneHQGlyph name='check' size={8} className='text-white bg-success'/></span>
                        </span>
                        <span>Connected</span>
                    </span>
                );
            case false:
                return (
                    <span className="text-warning-ink flex items-center gap-2">
                        <span className={'bg-warning-tint rounded-full'}>
                            <span className="inline-flex size-6 shrink-0 items-center justify-center rounded-full bg-warning-tint text-warning-ink"><PhoneHQGlyph name='info' size={14}/></span>
                        </span>
                        <span>Disconnected</span>
                    </span>
                );
            default:
                return null;
        }
    };

    return (
        <div className="flex items-center pt-2 text-sm">
            {getGoogleStatus(status)}
        </div>
    );
};